// Icons
import catalog from "assets/img/icons/sidebarIcons/catalog.png";
import customers from "assets/img/icons/sidebarIcons/customers.png";
import customize from "assets/img/icons/sidebarIcons/customize.png";
import dashboard from "assets/img/icons/sidebarIcons/dashboard.png";
import menuManage from "assets/img/icons/sidebarIcons/menuManage.png";
import order from "assets/img/icons/sidebarIcons/order.png";
import report from "assets/img/icons/sidebarIcons/report.png";
import request from "assets/img/icons/sidebarIcons/request.png";
import settings from "assets/img/icons/sidebarIcons/settings.png";
import easypaisa from "assets/img/icons/sidebarIcons/easypaisa.svg";
import table from "assets/img/icons/sidebarIcons/icons8-table-25 (1).png";
import easypaisaactive from "assets/img/icons/activeIcons/easypaisaactive.svg";
import staff from "assets/img/icons/sidebarIcons/staff.png";
import catalogactive from "assets/img/icons/activeIcons/catalogactive.png";
import customersactive from "assets/img/icons/activeIcons/customersactive.png";
import customizeactive from "assets/img/icons/activeIcons/customizeactive.png";
import dashboardactive from "assets/img/icons/activeIcons/dashboardactive.png";
import menuManageActive from "assets/img/icons/activeIcons/menuManageActive.png";
import orderactive from "assets/img/icons/activeIcons/orderactive.png";
import tableactive from "assets/img/icons/activeIcons/icons8-table-25 (2).png";
import reportactive from "assets/img/icons/activeIcons/reportactive.png";
import requestactive from "assets/img/icons/activeIcons/requestactive.png";
import settingsactive from "assets/img/icons/activeIcons/settingsactive.png";
import staffactive from "assets/img/icons/activeIcons/staffactive.png";
// Components
import AccountSettings from "views/AccountSettings";
import AllNotifcations from "views/AllNotifcations";
import Billing from "views/BillingSettings";
import Catalog from "views/Catalog";
import CheckoutQuestion from "views/CheckoutQuestion";
import ClientSettingMenu from "views/ClientSettingMenu";
import ClientSettings from "views/ClientSettings";
import Menus from "views/Menus";
import Customers from "views/Customers";
import Customization from "views/Customization";
import Table from "views/Tables";
import Holidays from "views/Holidays";
import KitchenStaff from "views/KitchenStaff";
// import OrdersResturant from "views/OrdersResturant";
import ConditionalOrders from "views/ConditionalOrders"; //Conditionally render the Orders component
import PaymentConnection from "views/PaymentConnection";
import PaymentsAndReports from "views/PaymentsAndReports";
import PickupOrDelivery from "views/PickupOrDelivery";
import PlatformFeedback from "views/PlatformFeedback";
import Requests from "views/Requests";
import RestaurantLanguage from "views/RestaurantLanguage";
import Merchants from "views/Merchants";
import Settings from "views/Settings";
import StoreTimings from "views/StoreTimings";
import SubAdmin from "views/SubAdmin";
import Subscription from "views/Subscription";
import Tutorials from "views/Tutorials";
import VenueSettingMenu from "views/VenueSettingMenu";
import ForgetPassword from "views/auth/ForgetPassword";
import Login from "views/auth/Login";
import SignUp from "views/auth/SignUp";
import LandingPage from "views/Landing/LandingPage";
import AboutUs from "views/Landing/AboutUs";
import Faqs from "views/Landing/Faqs";
import LandingTutorials from "views/Landing/LandingTutorials";
import ContactUs from "views/Landing/ContactUs";
import Drivers from "views/Drivers";
import Easypaisa from "components/Auth/Easypaisa";
import EasypaisaRequests from "views/EasypaisaRequests";
import CheckoutResponses from "views/CheckoutResponses";
import Categories from "components/Menu/Categories";
import Items from "components/Menu/Categories/Items";
import Index from "views/Index";
import Offers from "views/Offers";
import DriverRequests from "views/DriverRequests";
import PaymentResponse from "components/Auth/PaymentResponse";
import AdditionalCharges from "views/AdditionalCharges";
import Services from "views/Landing/Services";

var routes = [
  // Public
  {
    path: "/home",
    name: "Landing",
    component: LandingPage,
    layout: "public",
  },
  {
    path: "/about",
    name: "About us",
    component: AboutUs,
    layout: "public",
  },
  {
    path: "/services",
    name: "Our Services",
    component: Services,
    layout: "public",
  },
  {
    path: "/contact",
    name: "Contact us",
    component: ContactUs,
    layout: "public",
  },
  {
    path: "/tutorials",
    name: "Tutorials",
    component: LandingTutorials,
    layout: "public",
  },
  {
    path: "/faqs",
    name: "FAQS",
    component: Faqs,
    layout: "public",
  },
  {
    path: "/index",
    name: "Dashboard",
    icon: dashboard,
    activeIcon: dashboardactive,
    component: Index,
    layout: ["super-admin", "admin"],
    isMenu: true,
  },
  // Super Admin
  {
    path: "/merchants",
    name: "Merchants",
    icon: order,
    activeIcon: orderactive,
    component: Merchants,
    layout: "super-admin",
    isMenu: true,
  },
  {
    path: "/platform-feedback",
    name: "Platform Feedbacks",
    icon: request,
    activeIcon: requestactive,
    component: PlatformFeedback,
    layout: "super-admin",
    isMenu: true,
  },
  {
    path: "/sub-admin",
    name: "Sub-Admin",
    icon: staff,
    activeIcon: staffactive,
    component: SubAdmin,
    layout: "super-admin",
    role: "admin",
    isMenu: true,
  },
  {
    path: "/payments-reports",
    name: "Payments & Reports",
    icon: report,
    activeIcon: reportactive,
    component: PaymentsAndReports,
    layout: "super-admin",
    isMenu: true,
  },
  {
    path: "/subscription-requests",
    name: "Subscriptions",
    icon: easypaisa,
    activeIcon: easypaisaactive,
    component: EasypaisaRequests,
    layout: "super-admin",
    isMenu: true,
  },
  // Admin
  {
    path: "/menus",
    name: "Menus",
    icon: menuManage,
    activeIcon: menuManageActive,
    component: Menus,
    exact: true,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/menus/:id/categories",
    name: "Category",
    exact: true,
    component: Categories,
    layout: "admin",
  },
  {
    path: "/menus/:id/categories/:id/items",
    name: "Items",
    component: Items,
    layout: "admin",
  },
  {
    path: "/kitchen-staff",
    name: "Staff",
    icon: staff,
    activeIcon: staffactive,
    component: KitchenStaff,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/drivers",
    name: "Drivers",
    icon: staff,
    activeIcon: staffactive,
    component: Drivers,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/driver-requests",
    name: "Drivers Requests",
    icon: staff,
    activeIcon: staffactive,
    component: DriverRequests,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/customers",
    name: "Customers",
    icon: customers,
    activeIcon: customersactive,
    component: Customers,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/order",
    name: "Orders",
    icon: order,
    activeIcon: orderactive,
    component: ConditionalOrders,
    layout: "admin",
    isMenu: true,
  },
  {
    name: "Offers",
    path: "/offers",
    activeIcon: reportactive,
    icon: report,
    component: Offers,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/requests",
    name: "Requests",
    icon: request,
    activeIcon: requestactive,
    component: Requests,
    layout: "admin",
    isMenu: true,
  },
  {
    name: "Table",
    path: "/table",
    activeIcon: tableactive,
    icon: table,
    component: Table,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/catalog",
    name: "Catalog",
    icon: catalog,
    activeIcon: catalogactive,
    component: Catalog,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/checkoutQuestions",
    name: "Customer Feedback",
    icon: report,
    activeIcon: reportactive,
    component: CheckoutQuestion,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/checkout-responses/:id",
    name: "Checkout Responses",
    component: CheckoutResponses,
    layout: "admin",
  },
  {
    path: "/tutorials",
    name: "Tutorials",
    icon: catalog,
    activeIcon: catalogactive,
    component: Tutorials,
    layout: "admin",
    isMenu: true,
  },
  {
    name: "Customization",
    path: "/customization",
    activeIcon: customizeactive,
    icon: customize,
    component: Customization,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: AllNotifcations,
    layout: "admin",
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    icon: dashboard,
    activeIcon: dashboardactive,
    component: Subscription,
    layout: "admin",
    isMenu: true,
  },
  {
    path: "/settings/payment-connection",
    name: "Payment Connection",
    component: PaymentConnection,
    layout: "admin",
  },
  {
    path: "/settings/additional-charges",
    name: "Additional Charges",
    component: AdditionalCharges,
    layout: "admin",
  },
  {
    path: "/settings/client-setting-menu",
    name: "Setting",
    component: ClientSettingMenu,
    layout: "admin",
  },
  {
    path: "/settings/venue-setting-menu",
    name: "Setting",
    component: VenueSettingMenu,
    layout: "admin",
  },
  // {
  //   path: "/settings/venue-restaurant-currency",
  //   name: "Setting",
  //   component: RestaurantCurrency,
  //   layout: "admin",
  // },
  {
    path: "/settings/venue-restaurant-language",
    name: "Setting",
    component: RestaurantLanguage,
    layout: "admin",
  },
  {
    path: "/settings/store-timings",
    name: "Store Timings",
    icon: "fa fa-list text-primary",
    component: StoreTimings,
    layout: "admin",
  },
  {
    path: "/settings/pickup-or-delivery",
    name: "Pickup or Delivery",
    icon: "fa fa-list text-primary",
    component: PickupOrDelivery,
    layout: "admin",
  },
  {
    path: "/settings/tip-settings",
    name: "Client Settings",
    icon: "fa fa-list text-primary",
    component: ClientSettings,
    layout: "admin",
  },
  {
    path: "/settings/account",
    name: "Account Settings",
    icon: "fa fa-list text-primary",
    component: AccountSettings,
    layout: "admin",
  },
  {
    path: "/settings/billing",
    name: "Billing",
    icon: "fa fa-list text-primary",
    component: Billing,
    layout: "admin",
  },
  {
    path: "/settings/holidays",
    name: "Holidays",
    component: Holidays,
    layout: "admin",
  },
  {
    path: "/settings",
    name: "Settings",
    icon: settings,
    activeIcon: settingsactive,
    component: Settings,
    layout: "admin",
    isMenu: true,
  },
  // Auth
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: "auth",
  },
  {
    path: "/easypaisa",
    name: "Easypaisa",
    component: Easypaisa,
    layout: "auth",
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
    layout: "auth",
  },
  {
    path: "/payment-response",
    name: "Payment Response",
    component: PaymentResponse,
    layout: "auth",
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    icon: "ni ni-circle-08 text-pink",
    component: ForgetPassword,
    layout: "auth",
  },
];
export default routes;
